/**
 * 稳定版：判断是否存在有效数据
 * 有数据 → 返回 true（你要的默认）
 * 无数据 → 返回 false
 * 支持：字符串、数组、对象、布尔、null、undefined、数字
 */
export const hasData = value => {
  // null / undefined → 无数据
  if (value === null || typeof value === 'undefined') {
    return false;
  }

  // 字符串 → 有内容（非空、非纯空格）= true
  if (typeof value === 'string') {
    return value.trim() !== '';
  }

  // 数组 → 长度 > 0 = true
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  // 对象 → 有属性 = true（排除数组/null）
  if (typeof value === 'object') {
    return Object.keys(value).length > 0;
  }

  // 布尔 → true = 有效，false = 无效
  if (typeof value === 'boolean') {
    return value === true;
  }

  // 数字 → 非0、非NaN = true
  if (typeof value === 'number') {
    return !isNaN(value) && value !== 0;
  }

  // 其他类型默认当作有数据
  return true;
};
